import { render, staticRenderFns } from "./ReservationsView.vue?vue&type=template&id=5e0a6796&scoped=true&"
import script from "./ReservationsView.vue?vue&type=script&lang=js&"
export * from "./ReservationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0a6796",
  null
  
)

export default component.exports